<template>
  <div class="modal-pwd modal fade" id="forgottenPwd" tabindex="-1" role="dialog" aria-labelledby="forgottenPwdTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-pwd__header modal-header pb-0">
          <h5 class="modal-title d-none" id="forgottenPwdTitle">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span class="thin" :class="'text-' + $mainColor" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-pwd__body modal-body text-center mx-lg-5 px-5 my-4">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
